<template>
    <span class="ath-visual-dot br-c"
        :class="[data.cname]"
        :style="data.style"
        style="flex-grow: 0; flex-shrink: 0; padding: 0"></span>
</template>

<script>
import { isNeString, join } from '@aretheyhappy/utils';

export default {
    name: 'mead-dot',
    props: {
        /**
         * Sentiment/type of the dot (e.g. "positive", "neutral", "negative",
         * "default", "active"). Used to apply the `el--t-{value}` color class,
         * unless an explicit `color` is provided, in which case this is ignored
         * for styling purposes.
         */
        value: {type: String, default: () => 'positive'},
        /**
         * Size of the dot, applied as an `el--s-{uiSize}` class. One of "s", "m", "l".
         */
        uiSize: {type: String, default: () => 'm'},
        /**
         * Explicit background color (CSS color value) to use instead of the
         * sentiment-based color derived from `value`. Defaults to `false`, meaning
         * the color is determined entirely by `value`.
         */
        color: {type: [Boolean, String], default: () => false},
    },
    computed: {
        data: function () {
            const cname = join([
                !isNeString(this.color) ? `el--t-${this.value}` : false,
                `el--s-${this.uiSize}`,
            ], {delim: ' '});

            const style = Object.assign(
                {},
                isNeString(this.color)
                    ? {backgroundColor: this.color}
                    : {}
            );

            return {cname, style};
        },
    },
};
</script>

<style lang="scss" scoped>
span {
    display: inline-block;

    &.el--t-pos,
    &.el--t-positive {
        background-color: var(--c-sentiment-positive-bg)
    }

    &.el--t-neu,
    &.el--t-neutral {
        background-color: var(--c-sentiment-neutral-bg);
    }

    &.el--t-neg,
    &.el--t-negative {
        background-color: var(--c-sentiment-negative-bg);
    }

    &.el--t-def,
    &.el--t-default {
        background-color: var(--c-brand-default-bg);
    }

    &.el--t-active {
        background-color: var(--c-brand-active-bg);
    }

//
//  Sizes
//

    &.el--s-s {
        width: .6rem;
        height: .6rem;
    }

    &.el--s-m {
        width: .8rem;
        height: .8rem;
    }

    &.el--s-l {
        width: 1rem;
        height: 1rem;
    }
}
</style>
